module.exports = __webpack_public_path__ + "static/media/main idea.0c9b59a3.mp3";